var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRightGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3755 6.96628C21.4709 6.489 21.0501 6.06819 20.5729 6.16365L14.7872 7.32078C14.253 7.42762 14.0534 8.08673 14.4387 8.47196L16.1529 10.1861L12.4495 13.8895L9.51046 10.9505C9.34168 10.7817 9.11276 10.6869 8.87407 10.6869C8.63537 10.6869 8.40645 10.7817 8.23767 10.9505L2.87457 16.3136C2.52309 16.6651 2.52309 17.2349 2.87457 17.5864C3.22604 17.9379 3.79589 17.9379 4.14736 17.5864L8.87407 12.8597L11.8131 15.7987C12.1645 16.1502 12.7344 16.1502 13.0859 15.7987L17.4257 11.4589L19.0672 13.1005C19.4524 13.4857 20.1115 13.2861 20.2184 12.7519L21.3755 6.96628Z",
    fill: "#52A86E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRightGreen);
export default __webpack_public_path__ + "static/media/ArrowUpRightGreen.19f4dfcd5bbe1e0861bf50ff969cd6d5.svg";
export { ForwardRef as ReactComponent };